/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Button } from '@/primitives/Button';
import { Container } from '@/primitives/Container';

interface TokenFormActionsProps {
  onCancel: () => void;
  isSubmitting: boolean;
  hasSelectedPermissions: boolean;
}

export function TokenFormActions({ onCancel, isSubmitting, hasSelectedPermissions }: TokenFormActionsProps) {
  const { t } = useMimicTranslation('apiTokens');

  return (
    <Container horizontal gap="sm" style={{ justifyContent: 'flex-end', paddingTop: '8px' }}>
      <Button type="default" onClick={onCancel} disabled={isSubmitting}>
        {t('tokenForm.cancel')}
      </Button>
      <Button type="primary" htmlType="submit" loading={isSubmitting} disabled={!hasSelectedPermissions}>
        {t('createTokenModal.create')}
      </Button>
    </Container>
  );
}
